/**
 * Расписание автоматической коммуникации цикла сбора (BLUEPRINT 3.2 шаг 6, раздел 7, Stage 8).
 * Только данные: тексты — в `texts.ts` бота, постановка job — в `apps/api/src/jobs`.
 */
export const NOTIFY_SCHEDULE = {
  /** «Идёшь?» с кнопками — за столько часов до начала сбора */
  rsvpRequestHours: 48,
  /** Состав и площадка — за столько часов */
  details24Hours: 24,
  /** Адрес, маршрут, что взять — за столько часов */
  details3Hours: 3,
  /** Тихая обратная связь — через столько часов после конца сбора */
  feedbackHours: 3,
  /** Сколько часов после конца сбора открыта форма обратной связи (BLUEPRINT 2.2.3) */
  feedbackWindowHours: 12,
  /** Автоподтверждение сбора по числу «иду» — за столько часов до начала */
  confirmHours: 24,
  /** Напоминания об оплате сезона — за столько дней до дедлайна гарантии набора */
  payDeadlineDays: [3, 1],
  /** Дайджест капитану: ISO-день недели и час по таймзоне города */
  digestWeekday: 1,
  digestHour: 10,
} as const;

export type NotifySchedule = typeof NOTIFY_SCHEDULE;
